import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { doFilterList, toggleSelectType, setPageNumber, updateMaxPageNumber } from './access-list';

class FilterSearch extends Component {
  constructor(props) {
    super(props);

    this.updateTable = this.updateTable.bind(this);
    this.changeSearchKeyword = this.changeSearchKeyword.bind(this);
    this.selectTypeItem = this.selectTypeItem.bind(this);
    this.doSearchFilter = this.doSearchFilter.bind(this);

    // get all select value from refColumns
    let allSelectValues = [];
    this.props.refColumns.forEach((refColumn) => {
      allSelectValues.push(refColumn.field);
    });

    //init filter state
    this.state = {
      searchKeyword: '',
      selectValue: '',
      quickFilters: [],
      allSelectValues: allSelectValues,      
      refTable: null
    }

    // set this to ref
    if (props.refs) {
      props.refs(this);
    }
  }

  changeSearchKeyword = (e) => {
    this.setState({
      searchKeyword: e.target.value
    });
  }

  updateTable() {
    let refTable = (this.props.refTable) ? this.props.refTable : null;
    this.setState({
      refTable: refTable
    });
  }

  doSearchFilter = (e) => {
    let doFilter = false;

    // check trigger event type
    if (e.type === 'keydown') {
      // if keydown, check key code === 13 (Enter)
      if (e.keyCode === 13) {
        doFilter = true;
      }
    } else {
      doFilter = true;
    }

    if (doFilter) {
      let nowState = this.state;
      const table = nowState.refTable;

      if (this.props.doFilterFn) {
        // call filter methon
        this.props.doFilterFn(table, nowState.selectValue, nowState.searchKeyword, nowState.allSelectValues, this.props.refFilter, this.state.quickFilters);
      } else {
        // get filter type
        doFilterList(table, nowState.selectValue, nowState.searchKeyword, nowState.allSelectValues, this.props.refFilter, this.state.quickFilters);
      }

      // set Pagination init
      setPageNumber(1);
      updateMaxPageNumber(table);
    }
  }

  selectTypeItem = (e, value) => {
    this.setState({
      selectValue: value
    });

    toggleSelectType(value, this.props.filterId);
  }

  selectQuickFilterItem = (e, item) => {    
    const { filterId } = this.props;
    let elChecked = document.getElementById(filterId + '-' + item.name + '-' + item.field);
    let classTarget = elChecked.className;
    const doCheck = classTarget === 'icon-btn-checkbox-n';
    const classCheck = doCheck ? 'icon-btn-checkbox-p' : 'icon-btn-checkbox-n';
    elChecked.className = classCheck;

    // get old quick filters
    let quickFilters = this.state.quickFilters;

    if (doCheck) {
      quickFilters.push(item);

      this.setState({
        quickFilters: quickFilters
      });
    } else {
      let newQuickFilters = [];
      quickFilters.forEach(quickFilter => {
        if (quickFilter.field !== item.field || quickFilter.name !== item.name) {
          newQuickFilters.push(quickFilter);
        }  
      });

      this.setState({
        quickFilters: newQuickFilters
      });
    }
  }

  renderSelectRadioBtns = (refColumns, filterId) => {
    return refColumns.map((item, index) => {
      let dropdownClass = 'select-item';
      if (item.visible === false) {
        dropdownClass = 'no-display';
      }

      return (
        <Dropdown.Item key={index} onClick={(e) => this.selectTypeItem(e, item.field)} className={dropdownClass}>
          <span className='radio-icon-area'>
            <span id={filterId + '-radio-select-type-' + item.field} className='icon-radiobutton-n'/>
          </span>
          <span className='radio-text'>{item.title}</span>
        </Dropdown.Item>
      );
    });
  }

  initQuickFilters = () => {
    const { quickSearchFilter } = this.props;    
    if (quickSearchFilter && quickSearchFilter.length > 0) {      
      let newQuickFilters = [];
      quickSearchFilter.forEach(quickSearch => {
        quickSearch.filter.forEach (item => {
          if (item.checked) {
            newQuickFilters.push(item);
          }          
        });        
      });  
      this.setState({
        quickFilters:newQuickFilters 
      })
    }
  }

  renderQuickFilters = (quickFilters, filterId) => {
    if (quickFilters) {

      return quickFilters.map((item, index) => {
        const filterOptions = this.renderQuickFilterOptions(item.filter, filterId);
        return (
          <div className='area-quick-filter' key={index}>
            <div className='dropdown-tip'>{item.title}</div>
            { filterOptions }
          </div>
        );
      });
    } else {
      return (
        <div className='no-quick-filters'></div>
      );
    }    
  }

  renderQuickFilterOptions = (filter, filterId) => {
    return filter.map((item, index) => {
      let dropdownClass = 'select-item';
      if (item.visible === false) {
        dropdownClass = 'no-display';
      }

      let classChecked = 'icon-btn-checkbox-n';
      if (item.checked) {
        classChecked = 'icon-btn-checkbox-p';
      }

      return (
        <Dropdown.Item key={index} onClick={(e) => this.selectQuickFilterItem(e, item)} className={dropdownClass}>
          <span className='check-icon-area'>
            <span id={filterId + '-' + item.name + '-' + item.field} className={classChecked}/>
          </span>
          <span className='check-text'>{item.title}</span>
        </Dropdown.Item>
      );
    });
  }  

  componentDidMount() {
    // init quick filters
    this.initQuickFilters();

    // if call render will do this method
    this.updateTable();    
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    // if props change will call this method
    if (prevProps.refTable !== this.props.refTable) {
      this.updateTable();
    }
  }

  render() {
    const { filterId, refColumns, placeholder, noAllOption, quickSearchFilter, title } = this.props;
    const renderDeviceTypeOption = this.renderSelectRadioBtns(refColumns, filterId);
    const renderQuickSearchOption = this.renderQuickFilters(quickSearchFilter, filterId);
    const searchPlaceHolder = placeholder ? placeholder : 'Enter keyword...';
    const searchTitle = title ? <div className='dropdown-tip'>{ title }</div> : <div className='no-search-title'></div>;
    const classAllOption = noAllOption ? 'no-display' : 'select-item';

    return (
      <div id={this.props.filterId} className='search-filter-area'>
        <span className='search-icon-area' onClick={this.doSearchFilter}><span className='icon-search'></span></span>
        <span className='search-input-area'>
          <input type='text' id={filterId + '-filterSearch-keyword'} name='searchKeyword' value={this.state.searchKeyword} onKeyDown={this.doSearchFilter} onChange={this.changeSearchKeyword} 
            className='search-input' placeholder={searchPlaceHolder}></input>
        </span>
        <span className='search-dropdown-area'>
          <input type='hidden' id={filterId + '-filterSearch-type'} name='searchType' value={this.state.selectValue}/>
          <Dropdown>
            <Dropdown.Toggle variant="success" className='dropdown-toggle'>&nbsp;</Dropdown.Toggle>
            <Dropdown.Menu flip={true}>
              { searchTitle }
              <Dropdown.Item onClick={(e) => this.selectTypeItem(e, '')} className={ classAllOption }>
                <span className='radio-icon-area'><span id={filterId + '-radio-select-type-all'} className='icon-radiobutton-p'/></span><span className='radio-text'>All</span>
              </Dropdown.Item>
              { renderDeviceTypeOption }
              { renderQuickSearchOption }
            </Dropdown.Menu>            
          </Dropdown>
        </span>
      </div>
    )
  }
}

export default FilterSearch;